import { Group, Stack } from "@mantine/core"
import { IconAlertTriangle } from "@tabler/icons-react"
import { CountryFlag, Missing, TextCell, Tooltip } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { CountryIso3166 } from "@tfg/types/endpoints/library"

import { useAuth } from "~/store/auth-context"
import { COUNTRIES } from "~/utils/countries"

type Props = {
  productionSite?: {
    name: string
    address: string
    countryIso3166: CountryIso3166
    deletedAt: Date | null
  }
  showCountry?: boolean
}

export const ProductionSiteCell = ({
  productionSite,
  showCountry = true,
}: Props) => {
  const { isAdmin } = useAuth()
  const { t } = useTranslation("certificates")

  if (!productionSite) return <Missing />

  const countryInfo = productionSite.countryIso3166
    ? COUNTRIES[productionSite.countryIso3166]
    : undefined

  return (
    <Group gap={4} align="center" wrap="nowrap">
      {showCountry && countryInfo && (
        <Stack align="center" h="100%" justify="center">
          <CountryFlag
            countryIso3166={productionSite.countryIso3166}
            width={12}
          />
        </Stack>
      )}
      <TextCell value={productionSite.name} />
      {isAdmin && productionSite.deletedAt && (
        <Stack align="center" h="100%" justify="end">
          <Tooltip label={t("lists.columns.productionSite.deleted")}>
            <IconAlertTriangle
              width={12}
              height={12}
              color="var(--mantine-color-error)"
            />
          </Tooltip>
        </Stack>
      )}
    </Group>
  )
}
